import React from 'react';
import { Copy, FileText } from 'lucide-react';
import { useAppContext } from '../../context/AppContext';
import { useChat } from '../../hooks/useChat';
import ChatResponseDisplay from '../ChatResponseDisplay';
import WelcomeScreen from '../WelcomeScreen';

const MessageList = () => {
  const { theme, messages, loading, error } = useAppContext();
  const {
    copyToClipboard,
    copySuccess,
    showSourcesForMessage,
    setShowSourcesForMessage
  } = useChat();

  const renderFilePath = (source) => {
    const path = source.source_path || source.filename || 'N/A';
    if (!path || path === 'N/A') return <span>N/A</span>;

    const handleFileClick = (e) => {
      e.preventDefault();

      const textArea = document.createElement('textarea');
      textArea.value = path;
      document.body.appendChild(textArea);
      textArea.select();

      try {
        document.execCommand('copy');
        alert('File path copied: ' + path);
      } catch {
        alert('File path: ' + path);
      }

      document.body.removeChild(textArea);
    };

    return (
      <span
        onClick={handleFileClick}
        className="font-semibold text-blue-600 dark:text-blue-400 break-all cursor-pointer hover:underline"
      >
        {path}
        {source.slide_number && <span> - Slide {source.slide_number}</span>}
        {source.sheet_name && <span> - {source.sheet_name}</span>}
        {source.page_number && <span> - Page {source.page_number}</span>}
      </span>
    );
  };

  return (
    <div className="flex-grow p-6 overflow-y-auto scrollbar-hide messages-container">
      <div className="max-w-6xl mx-auto">

        {messages.length === 0 && !loading && <WelcomeScreen />}

        {messages.map((msg, index) => (
          <div key={index} className="flex items-start gap-4 mb-8">
            <div className="flex-1">

              <div className={theme === 'dark' ? 'text-gray-200' : 'text-gray-800'}>
                {msg.role === 'user' ? (
                  <p className="text-left text-2xl font-semibold">
                    {msg.content}
                  </p>
                ) : (
                  <ChatResponseDisplay
                    answer={msg.content}
                    sources={msg.sources}
                    theme={theme}
                  />
                )}
              </div>

              {msg.role === 'bot' && msg.content && (
                <>
                  <div className="flex items-center space-x-4 mt-2 text-gray-500">
                    <button onClick={() => copyToClipboard(msg.content)}>
                      {copySuccess ? 'Copied!' : <Copy size={18} />}
                    </button>

                    <button
                      onClick={() =>
                        setShowSourcesForMessage(
                          showSourcesForMessage === index ? null : index
                        )
                      }
                      disabled={!msg.sources?.length}
                    >
                      <FileText size={18} />
                    </button>
                  </div>

                  {showSourcesForMessage === index && msg.sources?.length > 0 && (
                    <div className="mt-2 p-3 rounded-lg bg-gray-100 dark:bg-gray-800">
                      <ul className="list-decimal pl-4 text-gray-600 dark:text-gray-300">
                        {msg.sources.map((source, idx) => (
                          <li key={idx} className="text-xs mb-2">
                            {renderFilePath(source)}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </>
              )}

            </div>
          </div>
        ))}

        {error && (
          <div className="text-red-500 text-center">
            {error}
          </div>
        )}

      </div>
    </div>
  );
};

export default MessageList;